// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"57":"index","205":"third-mall","480":"special","965":"price-history"}[chunkId] || chunkId) + "." + {"57":"e2274846","205":"7517c735","208":"caa42723","480":"295c3437","965":"d29c16b2"}[chunkId] + ".js";
};